/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type employees_UpdateEmployeeQualificationRequest = {
    countryIso?: string;
    description?: string;
    eqfLevel?: number;
    issuedBy?: string;
    minRatioChildren?: number;
    name?: string;
    roleLevel?: employees_UpdateEmployeeQualificationRequest.roleLevel;
};
export namespace employees_UpdateEmployeeQualificationRequest {
    export enum roleLevel {
        QUALIFIED = 'QUALIFIED',
        RECOGNITION_PENDING = 'RECOGNITION_PENDING',
        NOT_QUALIFIED = 'NOT_QUALIFIED',
    }
}

